import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=55fc5d86&scoped=true&"
import script from "./OrderManagement.vue?vue&type=script&lang=js&"
export * from "./OrderManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc5d86",
  null
  
)

export default component.exports